// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.queryBuilderDatePicker > div > div {
    padding: 0;
}

.queryBuilderDateRange {

}

.queryBuilderDateRange > div:first-child {
    padding: 4px 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/search/XSifterQueryBuilder.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;;AAEA;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".queryBuilderDatePicker > div > div {\r\n    padding: 0;\r\n}\r\n\r\n.queryBuilderDateRange {\r\n\r\n}\r\n\r\n.queryBuilderDateRange > div:first-child {\r\n    padding: 4px 14px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
